(function () {
  if (window.bnStkOfferReady) return;
  window.bnStkOfferReady = true;

  const CDN = 'https://cdn.shopify.com/s/files/1/0747/5386/7812/files/';

  function moneyFromCents(cents, format) {
    const amount = (Number(cents) / 100).toFixed(2).replace(/\.00$/, '');
    if (format && format.indexOf('amount') !== -1) {
      return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }
    return '$' + amount;
  }

  function planNameMatches(name, months) {
    const n = (name || '').toLowerCase();
    if (months === 1) return n.includes('1 month') || n.includes('1-month') || n.includes('every 1 month');
    if (months === 2) return n.includes('2 month') || n.includes('2-month') || n.includes('every 2 month');
    if (months === 3) return n.includes('3 month') || n.includes('3-month') || n.includes('every 3 month');
    return false;
  }

  function resolvePlanId(button, product) {
    if (!product) return button.dataset.sellingPlanId || '';
    const groups = product.selling_plan_groups || [];
    const plans = [];
    groups.forEach((group) => {
      (group.selling_plans || []).forEach((plan) => plans.push(plan));
    });
    if (!plans.length) return button.dataset.sellingPlanId || '';

    const explicit = button.dataset.sellingPlanId;
    if (explicit && plans.some((plan) => String(plan.id) === String(explicit))) return explicit;

    const match = (button.dataset.sellingPlanNameMatch || '').trim().toLowerCase();
    if (match) {
      const found = plans.find((plan) => (plan.name || '').toLowerCase().includes(match));
      if (found) return String(found.id);
    }

    const months = parseInt(button.dataset.subscriptionMonths, 10);
    if (months) {
      const found = plans.find((plan) => planNameMatches(plan.name, months));
      if (found) return String(found.id);
    }

    const position = parseInt(button.dataset.sellingPlanPosition, 10);
    if (position > 0 && plans[position - 1]) return String(plans[position - 1].id);
    return '';
  }

  function allocationFor(variant, planId) {
    if (!variant || !planId) return null;
    return (variant.selling_plan_allocations || []).find((allocation) => {
      const id = allocation.selling_plan_id || allocation.selling_plan?.id;
      return String(id) === String(planId);
    });
  }

  function shipByDate() {
    const date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setDate(date.getDate() + 1);
    return new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(date);
  }

  function getProduct(root) {
    const node = root.querySelector('[data-bn-stk-product-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function oneTimePrices(root) {
    const node = root.querySelector('[data-bn-stk-onetime-prices]');
    if (!node) return { 1: '$49', 2: '$98', 3: '$147' };
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return { 1: '$49', 2: '$98', 3: '$147' };
    }
  }

  function selectedPlan(root) {
    return root.querySelector('[data-bn-stk-plan].is-selected');
  }

  function updateGifts(root, planKey) {
    const qty = parseInt(selectedPlan(root)?.dataset.quantity || '1', 10);
    const gifts = Array.from(root.querySelectorAll('[data-bn-stk-gift]'));
    let availableCount = 0;
    let unlockedCount = 0;
    gifts.forEach((gift) => {
      const rule = gift.dataset.unlock || 'subscription';
      const minimum = rule === 'bags_3' ? 3 : rule === 'bags_2' ? 2 : 1;
      const available = gift.dataset.giftAvailable !== 'false';
      const unlocked = available && qty >= minimum;
      if (available) availableCount += 1;
      if (unlocked) unlockedCount += 1;
      gift.classList.toggle('is-unlocked', unlocked);
      gift.classList.toggle('is-coming', !available);
      gift.disabled = !available;
      const threshold = minimum + (minimum === 1 ? ' bag' : ' bags');
      const state = !available ? 'Coming at launch, for ' + threshold + '.' : unlocked ? 'Unlocked. ' + gift.dataset.activeLabel + '.' : 'Select ' + threshold + ' to unlock.';
      gift.setAttribute('aria-label', (gift.dataset.giftTitle || '') + '. ' + state);
      const status = gift.querySelector('[data-bn-stk-gift-status]');
      if (status) status.textContent = !available ? 'Coming at launch' : unlocked ? gift.dataset.activeLabel : gift.dataset.inactiveLabel;
    });
    const count = root.querySelector('[data-bn-stk-gift-count]');
    if (count) count.textContent = unlockedCount + ' of ' + availableCount + ' unlocked';
    const group = root.querySelector('.bn-stk__gifts');
    if (group) {
      group.style.setProperty('--stk-gift-available-count', availableCount);
      group.style.setProperty('--stk-gift-progress', (availableCount > 1 ? Math.max(0, unlockedCount - 1) / (availableCount - 1) * 100 : 0) + '%');
    }
  }

  function updateOneTimeLabel(root) {
    const button = root.querySelector('[data-bn-stk-onetime]');
    const plan = selectedPlan(root);
    if (!button || !plan) return;
    const qty = parseInt(plan.dataset.quantity || '1', 10);
    const prices = oneTimePrices(root);
    const product = getProduct(root);
    const variantId = button.dataset.variantId;
    const variant = product?.variants?.find((item) => String(item.id) === String(variantId));
    let total = prices[String(qty)] || prices[qty] || prices['1'];
    if (root.dataset.bnStkUseLiveOneTime === 'true' && variant && variant.price) {
      total = moneyFromCents(variant.price * qty, root.dataset.bnStkMoneyFormat);
    }
    const prefix = root.dataset.bnStkOneTimePrefix || 'One Time Purchase';
    button.textContent = prefix + ' (' + qty + ') · ' + total;
    button.setAttribute('aria-label', prefix + ', quantity ' + qty + ', total ' + total);
    button.dataset.quantity = String(qty);
    button.dataset.total = total;
  }

  function applyPlanToForm(root, plan) {
    const variantInput = root.querySelector('[data-bn-stk-variant-id]');
    const planInput = root.querySelector('[data-bn-stk-selling-plan]');
    const qtyInput = root.querySelector('[data-bn-stk-quantity]');
    if (variantInput) variantInput.value = plan.dataset.variantId || '';
    if (qtyInput) qtyInput.value = plan.dataset.cartQuantity || '1';
    if (planInput) {
      planInput.disabled = false;
      planInput.value = plan.dataset.sellingPlanId || '';
    }
  }

  function showError(root, message) {
    const error = root.querySelector('[data-bn-stk-error]');
    if (!error) return;
    if (!message) {
      error.hidden = true;
      error.textContent = '';
      return;
    }
    error.hidden = false;
    error.textContent = message;
  }

  function selectPlan(root, plan, broadcast) {
    if (!plan) return;
    root.querySelectorAll('[data-bn-stk-plan]').forEach((button) => {
      const on = button === plan;
      button.classList.toggle('is-selected', on);
      button.setAttribute('aria-checked', on ? 'true' : 'false');
      const perks = button.querySelector('.bn-stk__perks');
      if (perks) perks.hidden = !on;
    });
    applyPlanToForm(root, plan);
    updateGifts(root, plan.dataset.bnStkPlan);
    updateOneTimeLabel(root);
    const cta = root.querySelector('[data-bn-stk-cta]');
    if (cta) cta.disabled = plan.dataset.available === 'false';
    showError(root, '');
    if (broadcast) {
      document.dispatchEvent(new CustomEvent('bn:stk-plan', {
        detail: {
          planKey: plan.dataset.bnStkPlan,
          sourceId: root.dataset.sectionId,
          price: plan.dataset.price,
          savings: plan.dataset.savings,
          name: plan.dataset.name,
          quantity: plan.dataset.quantity
        }
      }));
    }
  }

  function showSlide(root, index, scroll = true, behavior = 'smooth') {
    const slides = root.querySelectorAll('[data-bn-stk-slide]');
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    slides.forEach((slide) => slide.classList.toggle('is-active', Number(slide.dataset.bnStkSlide) === next));
    root.querySelectorAll('[data-bn-stk-dot]').forEach((dot) => {
      dot.classList.toggle('is-active', Number(dot.dataset.bnStkDot) === next);
      dot.setAttribute('aria-current', Number(dot.dataset.bnStkDot) === next ? 'true' : 'false');
    });
    root.querySelectorAll('[data-bn-stk-thumb]').forEach((thumb) => {
      thumb.classList.toggle('is-active', Number(thumb.dataset.bnStkThumb) === next);
      thumb.setAttribute('aria-current', Number(thumb.dataset.bnStkThumb) === next ? 'true' : 'false');
    });
    root.dataset.slide = String(next);
    const track = root.querySelector('[data-bn-stk-track]');
    if (scroll && track && window.matchMedia('(max-width: 989px)').matches) {
      track.scrollTo({
        left: next * track.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior
      });
    }
  }

  async function addToCart(root, mode) {
    const form = root.querySelector('.bn-stk__form');
    const cta = root.querySelector('[data-bn-stk-cta]');
    if (!form) return;
    const plan = selectedPlan(root);
    if (mode === 'one_time') {
      const oneTime = root.querySelector('[data-bn-stk-onetime]');
      const variantInput = root.querySelector('[data-bn-stk-variant-id]');
      const planInput = root.querySelector('[data-bn-stk-selling-plan]');
      const qtyInput = root.querySelector('[data-bn-stk-quantity]');
      if (variantInput) variantInput.value = oneTime?.dataset.variantId || root.dataset.bnStkOneTimeVariant || '';
      if (qtyInput) qtyInput.value = oneTime?.dataset.quantity || plan?.dataset.quantity || '1';
      if (planInput) {
        planInput.value = '';
        planInput.disabled = true;
      }
    } else if (plan) {
      applyPlanToForm(root, plan);
      if (!plan.dataset.sellingPlanId && (getProduct(root)?.selling_plan_groups || []).length) {
        showError(root, root.dataset.bnStkErrorNoSellingPlan);
        return;
      }
      if (!plan.dataset.variantId) {
        showError(root, root.dataset.bnStkErrorNoVariant);
        return;
      }
    }

    form.querySelectorAll('input[name="selling_plan"]').forEach((input) => {
      if (!input.hasAttribute('data-bn-stk-selling-plan')) input.disabled = true;
    });
    const formData = new FormData(form);
    if (!formData.get('id')) {
      showError(root, root.dataset.bnStkErrorNoVariant);
      return;
    }
    if (mode !== 'one_time' && !formData.get('selling_plan') && (getProduct(root)?.selling_plan_groups || []).length) {
      showError(root, root.dataset.bnStkErrorNoSellingPlan);
      return;
    }

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
    if (config.headers) delete config.headers['Content-Type'];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    if (cta) cta.disabled = true;
    showError(root, '');

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add', config);
      const data = await response.json();
      if (data.status) {
        showError(root, data.description || data.message || 'Unable to add to cart.');
        return;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: data
        });
      }
      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
    } catch (error) {
      showError(root, root.dataset.bnStkErrorNetwork || 'Network error. Please try again.');
    } finally {
      if (cta && plan) cta.disabled = plan.dataset.available === 'false';
      else if (cta) cta.disabled = false;
      if (mode === 'one_time' && plan) applyPlanToForm(root, plan);
    }
  }

  function init(root) {
    if (root.dataset.bnStkInit === 'true') return;
    root.dataset.bnStkInit = 'true';
    const product = getProduct(root);
    const useLive = root.querySelector('[data-bn-stk-offer]') ? 'false' : 'false';
    root.dataset.bnStkUseLiveOneTime = root.dataset.bnStkUseLiveOneTime || 'true';

    root.querySelectorAll('[data-bn-stk-plan]').forEach((button) => {
      const resolved = resolvePlanId(button, product);
      if (resolved) button.dataset.sellingPlanId = resolved;
      const variant = product?.variants?.find((item) => String(item.id) === String(button.dataset.variantId))
        || product?.variants?.[0];
      if (variant && !button.dataset.variantId) button.dataset.variantId = String(variant.id);
      if (product && (product.selling_plan_groups || []).length && !button.dataset.sellingPlanId) {
        button.dataset.available = 'false';
      }
    });

    root.querySelectorAll('[data-bn-stk-ship-date]').forEach((ship) => { ship.textContent = shipByDate(); });

    const recommendedSupply = new URLSearchParams(window.location.search).get('supply');
    const recommendedPlan = ['1mo', '2mo', '3mo'].includes(recommendedSupply)
      ? root.querySelector('[data-bn-stk-plan="' + recommendedSupply + '"]')
      : null;
    const current = recommendedPlan || selectedPlan(root);
    if (current) selectPlan(root, current, Boolean(recommendedPlan));

    root.querySelectorAll('[data-bn-stk-plan]').forEach((button) => {
      button.addEventListener('click', () => selectPlan(root, button, true));
    });

    root.querySelectorAll('[data-bn-stk-gift]').forEach((gift) => {
      gift.addEventListener('click', () => {
        if (gift.dataset.giftAvailable === 'false' || gift.classList.contains('is-unlocked')) return;
        const key = gift.dataset.unlockPlan;
        const plan = root.querySelector('[data-bn-stk-plan="' + key + '"]');
        if (plan) selectPlan(root, plan, true);
      });
    });

    root.querySelector('[data-bn-stk-prev]')?.addEventListener('click', () => {
      showSlide(root, Number(root.dataset.slide || 0) - 1);
    });
    root.querySelector('[data-bn-stk-next]')?.addEventListener('click', () => {
      showSlide(root, Number(root.dataset.slide || 0) + 1);
    });
    root.querySelectorAll('[data-bn-stk-dot], [data-bn-stk-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = button.dataset.bnStkDot || button.dataset.bnStkThumb;
        showSlide(root, Number(index));
      });
    });

    const track = root.querySelector('[data-bn-stk-track]');
    if (track) {
      let scrollFrame = 0;
      track.addEventListener('scroll', () => {
        if (!window.matchMedia('(max-width: 989px)').matches || scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = 0;
          if (track.clientWidth) showSlide(root, Math.round(track.scrollLeft / track.clientWidth), false);
        });
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        const current = Number(root.dataset.slide || 0);
        const count = root.querySelectorAll('[data-bn-stk-slide]').length;
        const target = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: count - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        showSlide(root, target);
      });
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => {
          showSlide(root, Number(root.dataset.slide || 0), true, 'auto');
        }).observe(track);
      }
    }

    root.querySelectorAll('[data-bn-stk-acc]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.nextElementSibling;
        const open = button.getAttribute('aria-expanded') === 'true';
        const group = button.closest('[data-bn-stk-accordion]');
        group?.querySelectorAll('[data-bn-stk-acc]').forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          if (other.nextElementSibling) other.nextElementSibling.hidden = true;
        });
        if (!open && panel) {
          button.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });

    root.querySelector('.bn-stk__form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart(root, 'subscription');
    });
    root.querySelector('[data-bn-stk-onetime]')?.addEventListener('click', () => addToCart(root, 'one_time'));

    document.addEventListener('bn:stk-plan', (event) => {
      if (!event.detail || event.detail.sourceId === root.dataset.sectionId) return;
      const plan = root.querySelector('[data-bn-stk-plan="' + event.detail.planKey + '"]');
      if (plan && !plan.classList.contains('is-selected')) selectPlan(root, plan, false);
    });

    showSlide(root, 0, true, 'auto');
    void CDN;
    void useLive;
    void allocationFor;
  }

  document.querySelectorAll('[data-bn-stk-offer]').forEach(init);

  document.addEventListener('bn:stk-add', (event) => {
    const root = document.querySelector('[data-bn-stk-primary]') || document.querySelector('[data-bn-stk-offer]');
    if (root) addToCart(root, event.detail?.mode || 'subscription');
  });
})();
